import React, { Component } from "react";
import walkthrough from "../../../../../images/template-img/walkthrough-icon.png";
import automation from "../../../../../images/template-img/automation-icon.png";
import dataLoading from "../../../../../images/template-img/data-loading.png";
import webAutomationIcon from "../../../../../images/template-img/web-automation.png";
import userOnboardingIcon from "../../../../../images/template-img/user-onboarding.png";
import approval from "../../../../../images/template-img/approval-workflow.png";
import chatSupport from "../../../../../images/template-img/chat-support.png";
import emailSupport from "../../../../../images/template-img/email-support.png";
import extraction from "../../../../../images/template-img/extraction.png";
import fileFormat from "../../../../../images/template-img/file-format.png";
import ecommerce from "../../../../../images/template-img/guided-ecommerce.png";
import messenger from "../../../../../images/template-img/messenger-support.png";
import mis from "../../../../../images/template-img/MIS.png";
import survey from "../../../../../images/template-img/survey.png";
import voiceSupport from "../../../../../images/template-img/voice-support.png";
import webScraping from "../../../../../images/template-img/web-scraping.png";
import whatsapp from "../../../../../images/template-img/whatsapp-support.png";
import comingSoon from "../../../../../images/coming-soon.png";
import backArrow from "../../../../../images/back-arrow.png";
import blackArrow from "../../../../../images/arrow-back-black.png";
import info from "../../../../../images/info.png";
import browseIcon from "../../../../../images/modal-icons/upload-icon.png";
import mask from "../../../../../images/modal-icons/bg-mask.png";
import playBtn from "../../../../../images/modal-icons/play-btn.png";
import bulbIcon from "../../../../../images/modal-icons/bulb.png";
import dataTransferIcon from "../../../../../images/dataTransferIcon.png";
import skillSetImage from "../../../../../images/SkillsetImage.png";
import ReactTooltip from "react-tooltip";
import playIcon from "../../../../../images/play-circle.svg";

import questionIcon from "../../../../../images/create-template/question.png";
import guidanceIcon from "../../../../../images/create-template/guidance.png";
import taskIcon from "../../../../../images/create-template/task.png";
import processIcon from "../../../../../images/create-template/process.png";
import chatbotIcon from "../../../../../images/create-template/chatbot.png";
import webIcon from "../../../../../images/create-template/automated.png";

import {
  createDraftSkill,
  startRecord,
  stopRecord,
  changeActiveTab,
  sendRequestAccess,
  getSheetHeaders,
  getDraftSkills,
  createGenAiSkill,
  createAgentV2,
} from "../../../../../redux/actions/skill";
import { notify } from "../../../../../redux/actions/snack";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Checkbox, Tooltip, Button, Popover } from "antd";

import { DeleteTwoTone, PlusCircleOutlined } from "@ant-design/icons";

import axios from "axios";
import Counter from "../../../../../components/counter";
import { getKeycloackToken } from "../../../../../redux/actions/auth";
import { addMemberToOrganization } from "../../../../../redux/actions/organizationAction";

import documentIcon from "../../../../../images/my-skills-home/automation-icon.png";
import enablementIcon from "../../../../../images/my-skills-home/enablement.svg";
import automationIcon from "../../../../../images/my-skills-home/automation.svg";
import arrowIcon from "../../../../../images/my-skills-home/arrow-down-white.svg";

import chatGptIcon from "../../../../../images/my-skills-home/chat-gpt-icon.png";
import sendWhiteIcon from "../../../../../images/my-skills-home/submit-white.svg";

import excelIcon from "../../../../../images/template-img/data-loading.png";
import blankIcon from "../../../../../images/plus.svg";

import { createCollection } from "../../../../../redux/actions/collections";
import { createCollectionV2, getListModels } from "../../../../../redux/actions/collectionsV2";

import $ from "jquery";
import { Editor } from "react-draft-wysiwyg";
import { stateToHTML } from "draft-js-export-html";
import Loader from "../../../../../components/loader";
import { createId } from "@paralleldrive/cuid2";

class SkillStart extends Component {
  state = {
    SKILL_NAME: "",
    SKILL_DESCRIPTION: "",
    TEMPLATE: "",
    isRecording: false,
    SKILL_ID: null,
    isLoading: false,
    sheetUrl: null,
    fileUrl: null,
    sheetName: null,
    sheetRange: null,
    stopRecording: false,
    name: "",
    email: "",
    uploadedFileName: "",
    toogleFileView: false,
    isSendingInvite: false,
    requestTemplate: "",
    showCreateTemplate: false,
    isErrorDescription: false,
    dataHeaders: null,
    defaultTemplate: true,
    collectionName: "",
    collectionDescription: "",
    showWalkthroughTemplate: false,
    baseLanguage: "en",
    model: "gpt-4o",
    selectedOption: "files",
    hostname: "",
    username: "",
    password: "",
    port: "",
    databaseType: "",
    isSSL: false,
    response_language: "en",
    selectedLiveSearch: "web_scrape",
    models: [],
    agentDescription: "",
    liveSearchUrl: [""],
    collectionNameError: "",
    advancedSettings: "",
    advancedSettingsOption: "",
    dbSchemas: "",
    useTablesList: "",
    useViewsList: "",
    neglectViewList: "",
    neglectTableList: "",
    advancedSettings: false,
    advancedSettingsOption: 1
  };

  // Add this new method here
  validateCollectionName = (value) => {
    // First, check if the string contains any special characters except underscore
    const specialCharRegex = /[^a-zA-Z0-9_]/;
    
    if (specialCharRegex.test(value)) {
      return "Special characters are not allowed except underscore (_)";
    }
  
    // Check if it starts with a letter (if there's any input)
    if (value.length > 0 && !/^[a-zA-Z]/.test(value)) {
      return "Collection name must start with a letter";
    }
    
    return ""; // Return empty string if all validations pass
  };


  fetchData = async () => {
      const models = await getListModels();
      this.setState({ models });
  };

  checkOrgFilter = () => {
    let orgFilterFlag = false;
    try {
      const orgIdToFilterList = process.env
        ?.REACT_APP_FILTERED_ORG_IDS_COLLECTION
        ? JSON.parse(process.env.REACT_APP_FILTERED_ORG_IDS_COLLECTION)
        : [];
      orgFilterFlag = orgIdToFilterList?.includes(
        JSON.parse(this.props.organizationReducer.currentOrganization.id)
      );
    } catch {
      orgFilterFlag = false;
    }
    return orgFilterFlag;
  };

  newCollection = async () => {
    this.setState({
      isLoading: true,
    });

    // Add this validation check
  if (this.state.collectionNameError) {
    this.props.notify("error", "Please fix the collection name errors before submitting");
    this.setState({
      isLoading: false,
    });
    return;
  }

    let collectionData = {};
    let userDetails = this.props?.organizationReducer?.currentOrganization;
    collectionData["name"] = this.state.collectionName;
    collectionData["collectionDescription"] = this.state.collectionDescription;
    collectionData["response_language"] = this.state.response_language;
    const regex = /^[a-zA-Z0-9_]+$/; // all alphanumeric values and _ only allowed
    const isCollectionNameValid = regex.test(this.state.collectionName);

    if (isCollectionNameValid) {
      if (this.state.selectedOption === "database") {
        if (
          !this.state.hostname ||
          !this.state.username ||
          !this.state.password ||
          !this.state.port ||
          !this.state.databasename ||
          (this.state.advancedSettings && this.state.dbSchemas?.length < 1)
        ) {
          this.props.notify("error", "All fields are required.");
          this.setState({
            isLoading: false,
          });
          return;
        }
      }
      if (
        (this.state.selectedOption === "live_search" &&
          this.state.selectedLiveSearch == "web_scrape" &&
          this.state.liveSearchUrl.length === 0) ||
        (this.state.selectedOption === "live_search" &&
          this.state.liveSearchUrl.some((url) => url.trim() === ""))
      ) {
        this.props.notify("error", "URL Cannot be empty for web scrape");
        this.setState({
          isLoading: false,
        });
        return;
      }
      let orgFilterFlag = false;
      try {
        const orgIdToFilterList = process.env
          ?.REACT_APP_FILTERED_ORG_IDS_COLLECTION
          ? JSON.parse(process.env.REACT_APP_FILTERED_ORG_IDS_COLLECTION)
          : [];
        orgFilterFlag = orgIdToFilterList?.includes(
          JSON.parse(this.props.organizationReducer.currentOrganization.id)
        );
      } catch {
        orgFilterFlag = false;
      }

      const groupPlan = this.props.userReducer.groupPlan;
      let planType;
      if (groupPlan?.planId == 4) {
        planType = "team";
      } else if (groupPlan?.planId == 5) {
        planType = "business";
      } else {
        planType = "pro";
      }

      let createResponse;
      if (orgFilterFlag) {
        createResponse = await createCollection(collectionData);
      } else {
        collectionData["planType"] = planType;
        collectionData["baseLanguage"] = this.state?.baseLanguage;
        collectionData["model"] = this.state.model;
        collectionData["source"] = this.state.selectedOption;

        collectionData["urls"] = this.state.liveSearchUrl;
        collectionData["selectedLiveSearch"] = this.state.selectedLiveSearch;

        let sourceSetting;
        if(this.state.advancedSettings){
          sourceSetting = {
            hostname: this.state.hostname,
            username: this.state.username,
            password: this.state.password,
            databaseName: this.state.databasename,
            port: this.state.port,
            isSSL: this.state.isSSL,
            databaseType: this.state.databaseType,
            db_schemas: this.state.dbSchemas.split(",")
          };
          if(this.state.advancedSettingsOption == 1){
            sourceSetting.use_tables = this.state.useTablesList.split(",")
            sourceSetting.use_views = this.state.useViewsList.split(",")
          }else{
            sourceSetting.neglect_view = this.state.neglectViewList.split(",")
            sourceSetting.neglect_table = this.state.neglectTableList.split(",")
          }
        }else{
          sourceSetting = {
            hostname: this.state.hostname,
            username: this.state.username,
            password: this.state.password,
            databaseName: this.state.databasename,
            port: this.state.port,
            isSSL: this.state.isSSL,
            databaseType: this.state.databaseType,
          };
        }

        collectionData["source_setting"] = JSON.stringify(
          sourceSetting,
          null,
          2
        );
        createResponse = await createCollectionV2(collectionData);
      }

      if (createResponse?.data?.status == "OK") {
        $(".modal-backdrop").hide();
        if (this.state.selectedOption == "transcribe") {
          this.props.history.push(
            `/transcribe?name=${userDetails?.id}_${this.state.collectionName}`
          );
        }
        // this.checkOrgFilter()
        //   ? this.props.history.push(
        //       `/collections?name=${this.state.collectionName}`
        //     )
        //   : this.props.history.push(
        //       `/collections?name=${userDetails?.id}_${this.state.collectionName}`
        //     );

        this.checkOrgFilter()
          ? this.state.selectedOption === "transcribe"
            ? this.props.history.push(
                `/transcribe?name=${userDetails?.id}_${this.state.collectionName}`
              )
            : this.props.history.push(
                `/collections?name=${userDetails?.id}_${this.state.collectionName}`
              )
          : this.state.selectedOption === "transcribe"
          ? this.props.history.push(
              `/transcribe?name=${userDetails?.id}_${this.state.collectionName}`
            )
          : this.props.history.push(
              `/collectionWorkspace?name=${userDetails?.id}_${this.state.collectionName}`
            );

        this.props.notify("success", createResponse?.data?.message);
      } else {
        this.props.notify("error", createResponse?.data?.message);
      }
    } else {
      this.props.notify(
        "error",
        "Collection Name contains invalid characters. Please use only letters, digits, and underscores."
      );
    }
    this.setState({
      isLoading: false,
    });
  };

  sendAccessReq = () => {
    let userDetail = this.props?.userReducer?.user;
    let userInfo = {
      Name: userDetail.name,
      Email: userDetail.email,
      contactNumber: userDetail.contactNumber,
    };
    let tempDetail = this.state.requestTemplate;
    let reqData = { userInfo, tempDetail };
    if (this.props.sendRequestAccess(reqData))
      this.props.notify("success", "Request Submitted successfully");
    else this.props.notify("error", "Request Submission failed");
  };

  onStartRecord = async (id) => {
    let markerIndex = 0;
    let skillId = id;
    let data = { skillId, markerIndex };
    const startData = this.props.startRecord(data);
    if (startData) {
      this.setState({
        isRecording: true,
      });
    }
  };

  onStopRecord = () => {
    this.setState({
      stopRecording: true,
    });
    let data = {
      deviceId: this.props.skillReducer.draftSession,
      skillId: this.state.SKILL_ID,
      markerIndex: 0,
    };
    const stopData = this.props.stopRecord(data);
    if (stopData) {
      setTimeout(() => {
        this.setState({
          isRecording: false,
          stopRecording: false,
        });
        this.props.history.push(`/dashboard/skills/viewSkill/${data.skillId}`);
        $(".modal-backdrop").hide();
      }, 5000); // redirect in 5 secs
    }
  };

  checkField = () => {
    if (this.state.SKILL_NAME.trim() === "") {
      this.setState({
        isError: true,
      });
    }
    if (this.state.SKILL_DESCRIPTION.trim() === "") {
      this.setState({
        isErrorDescription: true,
      });
    }
  };

  // handleCreateGenAiSkill = async () => {
  //   this.setState({
  //     isLoading: true,
  //   });
  handleEditUrlChange = (value, index) => {
    const updatedUrls = [...this.state.liveSearchUrl];
    updatedUrls[index] = value.trim(); // Use trim to clean up the input

    this.setState({ liveSearchUrl: updatedUrls });
  };

  handleAddEditUrl = () => {
    const updatedUrls = [...this.state.liveSearchUrl, ""];

    this.setState({ liveSearchUrl: updatedUrls });
  };

  handleDeleteEditUrl = (index) => {
    const updatedUrls = [...this.state.liveSearchUrl];

    updatedUrls.splice(index, 1);

    this.setState({ liveSearchUrl: updatedUrls });
  };

  //   const { currentOrgUser, currentOrganization } =
  //     this.props.organizationReducer;

  //   if (currentOrgUser.role_id == "1") {
  //     this.props.notify(
  //       "error",
  //       "You do not have privileges to create a skill in the selected team"
  //     );
  //     this.setState({
  //       isLoading: false,
  //     });
  //     return;
  //   }
  //   if (this.state.SKILL_NAME.trim() === "") {
  //     this.props.notify("error", "Skill name cannot be empty");
  //     this.setState({
  //       isLoading: false,
  //     });
  //     return;
  //   }
  //   if (this.state.SKILL_DESCRIPTION.trim() === "") {
  //     this.props.notify("error", "Skill description cannot be empty");
  //     this.setState({
  //       isLoading: false,
  //     });
  //     return;
  //   } else {
  //     let newSkillId = createId();
  //     let skill = {
  //       ...this.state,
  //       SKILL_NAME: this.state.SKILL_NAME,
  //       USER_ID: this.props.userReducer.user_id,
  //       TYPE: "regularSkill",
  //       organisationId: currentOrganization?.id || null,
  //       status: "self",
  //       USER_EMAIL: this.props.userReducer.user.email,
  //       Rating: { upVotes: [], downVotes: [], userComments: [] },

  //       v2AgentId: "V1AutomationAgent-cm1q6e1z20006hpmvd3k1dp3p",
  //       v2SkillId: newSkillId,
  //     };
  //     const createSkill = await this.props.createDraftSkill(skill, () => {});

  //     if (createSkill) {
  //       this.setState({
  //         isLoading: false,
  //       });

  //       this.props.notify("success", "Agent created successfully");
  //       this.props.history.push(
  //         `/dashboard/skills/createAutomationV2/${newSkillId}`
  //       );
  //       this.props.changeActiveTab("Draft");
  //       $(".modal-backdrop").hide();
  //     } else {
  //       this.setState({
  //         isLoading: false,
  //       });

  //       this.props.notify(
  //         "error",
  //         `Something went wrong.Unable to create skill`
  //       );
  //     }
  //   }
  // };

  handleSubmit = async () => {
    try {
      this.setState({
        isLoading: true,
      });

      const { currentOrgUser, currentOrganization } =
        this.props.organizationReducer;

      if (currentOrgUser.role_id == "1") {
        this.props.notify(
          "error",
          "You do not have privileges to create a skill in the selected team"
        );
        this.setState({
          isLoading: false,
        });
        return;
      }
      if (this.state.SKILL_NAME.trim() === "") {
        this.props.notify("error", "Skill name cannot be empty");
        this.setState({
          isLoading: false,
        });
        return;
      }
      if (this.state.SKILL_DESCRIPTION.trim() === "") {
        this.props.notify("error", "Skill description cannot be empty");
        this.setState({
          isLoading: false,
        });
        return;
      } else {
        let skill = {
          ...this.state,
          SKILL_NAME: this.state.SKILL_NAME,
          USER_ID: this.props.userReducer.user_id,
          TYPE: "regularSkill",
          organisationId: currentOrganization?.id || null,
          status: "self",
          USER_EMAIL: this.props.userReducer.user.email,
          Rating: { upVotes: [], downVotes: [], userComments: [] },
        };
        if (this.state.TEMPLATE === "GenAi Automation") {
          let _agent = {
            name: this.state.SKILL_NAME,
            description: this.state.agentDescription,
          };
          let res = await this.props.createAgentV2(_agent);
          if (!res?.success) {
            throw new Error(`${res?.message}`);
            
          }
          skill["v2AgentId"] = res?.data;

          skill["v2SkillId"] = createId();
        }
        if (this.state.sheetUrl && this.state.sheetName) {
          let headers = await this.props.getSheetHeaders(
            this.state.sheetUrl,
            this.state.sheetName
          );
          skill.dataHeaders = headers;
        }

        const createSkill = await this.props.createDraftSkill(skill, () => {});
        if (createSkill?.data?.status) {
          // this.props.getDraftSkills()
          this.setState({
            isLoading: false,
            isRecording: true,
            SKILL_ID: createSkill.data.data.id,
          });

          this.props.notify("success", "Agent created successfully");
          if (this.state.TEMPLATE === "GenAi Automation") {
            this.props.history.push(
              `/dashboard/skills/createAutomationV2/${encodeURIComponent(createSkill?.data?.data?.SKILL_NAME)}&${createSkill?.data?.data?.v2AgentId}&${createSkill.data.data.v2SkillId}?draftId=${createSkill?.data?.data?.id}&orgId=${createSkill?.data?.data?.organizationId}`
            );
          } else {
            this.props.history.push(
              `/dashboard/skills/viewSkill/${createSkill.data.data.id}`
            );
          }

          this.props.changeActiveTab("Draft");
          $(".modal-backdrop").hide();
        } else {
          if (createSkill?.msg) {
            this.setState({
              isLoading: false,
            });

            this.props.notify("error", `${createSkill.msg}`);
          } else if (!createSkill?.data?.status) {
            this.setState({
              isLoading: false,
            });
            this.props.notify("error", `${createSkill?.data?.data}`);
          }
        }
      }
    } catch (error) {
      console.log(error, "Error: WorkFlow Creation");
      this.setState({
        isLoading: false,
      });
      this.props.notify("error",`WorkFlow Agent Creation failed: ${error}`);
      $(".modal-backdrop").hide();
    }
  };

  isCollectionInfoFilled = () => {
    return (
      this.state.collectionName.trim() !== "" &&
      this.state.collectionDescription.trim() !== ""
    );
  };

  onFieldChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    const typedCharactersElement = this.state.SKILL_NAME?.length + 1;
    const maximumCharacters = 150;
    if (typedCharactersElement == maximumCharacters) {
      this.props.notify(
        "warning",
        "Skill name should not be more than 150 words"
      );
      return false;
    }

    if (this.state.SKILL_NAME.trim() !== "") {
      this.setState({
        isError: false,
      });
    }
    if (this.state.SKILL_DESCRIPTION.trim() !== "") {
      this.setState({
        isErrorDescription: false,
      });
    }
  };

  toggleFileView = () => {
    if (this.state.SKILL_NAME !== "" && this.state.SKILL_DESCRIPTION !== "") {
      this.setState({
        toogleFileView: true,
      });
      // if (
      //   this.state.SKILL_NAME.includes("-") ||
      //   this.state.SKILL_NAME.includes(" ")
      // ) {
      //   this.props.notify(
      //     "error",
      //     "' - ' and 'spaces' not allowed in skill name"
      //   );
      // } else {
      //   $("#skillInputFields").slideUp("fast");
      //   $("#skillFileFields").animate({ opacity: 1 }).slideDown("fast");
      // }

      $("#skillInputFields").slideUp("fast");
      $("#skillFileFields").animate({ opacity: 1 }).slideDown("fast");
    } else {
      this.props.notify("error", "Skill name and description cannot be empty");
    }
  };

  toggleFileViewBack = () => {
    $("#skillFileFields").slideUp("fast");
    $("#skillInputFields").animate({ opacity: 1 }).slideDown("fast");
  };

  addFileUrl = (e) => {
    var fileUrl = e.target.value;
    if (fileUrl != "") {
      this.setState({
        sheetUrl: e.target.value,
      });
    }
  };

  addFile = async (e) => {
    var _spreadSheetFile = e.target.files[0];
    if (!_spreadSheetFile) {
      this.setState({
        uploadedFileName: this.state.uploadedFileName,
      });
    } else {
      try {
        let token = await getKeycloackToken();
        var _data = new FormData();
        _data.append("file", e.target.files[0]);
        var config = {
          url: `${process.env.REACT_APP_BOT_SERVICE_URL}/upload/xl-sheet`,
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: _data,
        };
        const {
          data: {
            data: { url },
          },
        } = await axios(config);
        this.setState({
          sheetUrl: url,
          uploadedFileName: e.target.files[0].name,
        });
      } catch (e) {
        this.props.notify("error", e.response.data.message);
      }
    }
  };

  async componentDidMount() {
    this.fetchData();
    window.$('[data-toggle="popover"]').popover({
      container: "body",
    });
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  onEditorStateChange = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const blocks = contentState.getBlockMap();
    if (this.state.TEMPLATE === "GenAi Automation") {
      this.setState({
        agentDescription: contentState.getPlainText(),
      });
    }
    const fontFamilies = [
      "Arial",
      "Calibri",
      "Georgia",
      "Impact",
      "Tahoma",
      "Times New Roman",
      "Verdana",
    ];
    let fontFamiliesString = "";
    let htmlWithStyles = stateToHTML(contentState);

    blocks.forEach((block) => {
      const inlineStyles = block.getInlineStyleAt(0);
      const fontFamilyStyle = inlineStyles.find(
        (style) =>
          style.startsWith("fontfamily-") || fontFamilies.includes(style)
      );

      if (fontFamilyStyle) {
        const fontFamily = fontFamilyStyle.replace("fontfamily-", "");
        if (fontFamilies.includes(fontFamily)) {
          fontFamiliesString = fontFamily;
          htmlWithStyles = `<span style="font-family: ${fontFamily}">${htmlWithStyles}</span>`;
        }
      }
    });

    this.setState({
      editorState,
      SKILL_DESCRIPTION: htmlWithStyles,
    });
  };

  submitInvite = async () => {
    this.setState({ isSendingInvite: true });
    const organization_id =
      this.props.organizationReducer.currentOrganization.id;

    if (
      this.state.email != "" &&
      this.state.name != "" &&
      this.validateEmail(this.state.email)
    ) {
      await this.props.addMemberToOrganization({
        email: this.state.email,
        name: this.state.name,
        organization_id: organization_id.toString(),
        role_id: "2",
      });
      $(".close").click();
      this.setState({ isSendingInvite: false, email: "", name: "" });
    } else {
      this.setState({ isSendingInvite: false });
      if (this.state.name === "") {
        this.props.notify("error", "Please Enter Name");
      } else {
        this.props.notify("error", "Please Enter Email");
      }
    }
  };

  render() {
    const toolbarOptions = {
      options: ["inline", "blockType", "fontFamily", "list", "history"],
      inline: {
        options: ["bold", "italic", "underline"],
      },
      blockType: {
        options: ["Normal", "H1", "H2", "H3", "H4", "H5", "H6"],
      },
      fontFamily: {
        options: [
          "Arial",
          "Calibri",
          "Georgia",
          "Impact",
          "Tahoma",
          "Times New Roman",
          "Verdana",
        ],
      },
      list: {
        options: ["unordered", "ordered"],
      },
      history: {
        options: ["undo", "redo"],
      },
    };
    const getDesktopWalkthrough = () => {
      return (
        <div
          className="ms-box"
          data-toggle="modal"
          data-target="#recordModal"
          onClick={() =>
            this.setState({
              TEMPLATE: "Desktop Walkthrough",
            })
          }
        >
          <div className="ms-box-icon">
            <img src={enablementIcon} />
          </div>
          <button className="btn btn-select">Create</button>
          <div className="ms-box-ct">
            <h5>Desktop Co-browsing AI Agent</h5>
            <p>
              Desktop Co-browsing AI Agent can enable teams to automate
              repetitive digital tasks on your desktop. Use simple no-code show
              and tell interface to create and share automations for self or the
              team. This is equalent to Robotic Process Automation with all
              powerful desktop automation features.
            </p>
          </div>
        </div>
      );
    };

    const displayDefaultTemplate = () => {
      return (
        <div className="ms-ct ms-p1 scrollable">
          <div className="ms-title">
            <div className="ms-flex-title">
              <h1 className="ai-coach-text">
                {/* I'm your AI Coach. I will help you create your AI Agent */}
                Choose Your AI Agent template to get started
              </h1>
              <div className="rt-btns">
                {currentOrganization?.isAdmin ? (
                  <button
                    className="btn btn-primary"
                    onClick={() => this.props.history.push("/pricing")}
                  >
                    Pricing
                  </button>
                ) : null}

                {currentOrganization?.isAdmin ? (
                  <button
                    className="btn btn-outline"
                    data-toggle="modal"
                    data-target="#inviteModal"
                  >
                    + Invite Team Members
                  </button>
                ) : null}
              </div>
            </div>
            {/* { <span className="sm-tag">Supervity AI Coach</span> } */}
            {/* <h2>Choose Your AI Agent template to get started</h2> */}
          </div>
          <div className="ms-flex">
            <div
              data-toggle="modal"
              data-target="#inviteModal1"
              className="ms-box"
              onClick={(e) => {}}
            >
              <div className="ms-box-icon">
                <img src={questionIcon} />
              </div>
              <button className="btn btn-select">Create</button>
              <div className="ms-box-ct">
                <h5>Knowledge AI Agent</h5>
                <Popover
                  overlayStyle={{ width: 300 }}
                  content="Configure the AI agent with your team's or organization's
                    knowledge by simply adding collections of documents, URLs and
                    videos etc. Once added - your teams can instantly engage with
                    the AI Agent in natural language to discover information from
                    the collection of data. Comes with powerful RAG (Retrieval
                    Augmentated Generation) capabilities."
                >
                  <p>
                    Configure the AI agent with your team's or organization's
                    knowledge by simply adding collections of documents, URLs
                    and videos etc. Once added - your teams can instantly...
                  </p>
                </Popover>
              </div>
            </div>
            <div
              className="ms-box"
              // data-toggle="modal"
              // data-target="#recordModal"
              onClick={() =>
                this.setState({
                  showWalkthroughTemplate: true,
                  automationTemplate: false,
                  defaultTemplate: false,
                })
              }
            >
              <div className="ms-box-icon">
                <img src={guidanceIcon} />
              </div>
              <button className="btn btn-select">Create</button>
              <div className="ms-box-ct">
                <h5>Co-browsing AI Agent</h5>
                <Popover
                  overlayStyle={{ width: 300 }}
                  content="Create and share AI enabled in-app walkthroughs across your
                  organizational apps to digitally enable your employees,
                  customers and suppliers etc. AI Agent can also be connected
                  with knowledge AI Agent to answer user queries in natural
                  language. This AI Agent can also power digital adoption and
                  customer/citizen experiences across web and desktop apps."
                >
                  <p>
                    Create and share AI enabled in-app walkthroughs across your
                    organizational apps to digitally enable your employees,
                    customers and suppliers etc. AI Agent can also...
                  </p>
                </Popover>
              </div>
            </div>

            <div
              className="ms-box"
              onClick={(e) => {
                this.setState({
                  defaultTemplate: false,
                  automationTemplate: true,
                  showWalkthroughTemplate: false,
                });
                e.stopPropagation();
              }}
            >
              <div className="ms-box-icon">
                <img src={taskIcon} />
              </div>
              <button className="btn btn-select">Create</button>
              <div className="ms-box-ct">
                <h5>Robotic Automation Agent</h5>
                <p>
                  AI coach can enable teams to automate repetitive digital
                  tasks. Use simple no-code show and tell interface to create
                  and share automations for self or the team.
                </p>
              </div>
            </div>

            <div
              className="ms-box"
              data-toggle="modal"
              data-target="#recordModal"
              onClick={() =>
                this.setState({
                  TEMPLATE: "Process Discovery",
                })
              }
            >
              <div className="ms-box-icon">
                <img src={processIcon} />
              </div>
              <button className="btn btn-select">Create</button>
              <div className="ms-box-ct">
                <h5>Process Discovery AI Agent</h5>
                <p>
                  Identify and analyse business processes that are suitable for
                  automation by recording actions between users and workflows to
                  reveal exactly what’s required to optimize them.
                </p>
              </div>
            </div>

            {/* <div
              className="ms-box"
              data-toggle="modal"
              data-target="#inviteModal1"
            >
              <div className="ms-box-icon">
                <img src={chatbotIcon} />
              </div>
              <button className="btn btn-select">Create</button>
              <div className="ms-box-ct">
                <h5>AI Chatbot for Support</h5>
                <p>
                  Enhance the customer experience & operational efficiency and
                  allow human agents to focus on more complex and nuanced
                  customer needs.
                </p>
              </div>
            </div> */}

            {/* <div
              className="ms-box"
              data-toggle="modal"
              data-target="#recordModal"
              onClick={() =>
                this.setState({
                  TEMPLATE: "WebAutomation",
                })
              }
            >
              <div className="ms-box-icon">
                <img src={webIcon} />
              </div>
              <button className="btn btn-select">Create</button>
              <div className="ms-box-ct">
                <h5>Web Automation</h5>
                <p>
                  Save time and effort in performing repetitive tasks on any
                  website or web application. Capture and replay the web
                  automation steps easily.
                </p>
              </div>
            </div> */}

            {/* GenAi Automation  */}

            <div
              className="ms-box"
              data-toggle="modal"
              data-target="#recordModal"
              onClick={() =>
                this.setState({
                  TEMPLATE: "GenAi Automation",
                })
              }
            >
              <div className="ms-box-icon">
                <img src={processIcon} />
              </div>
              <button className="btn btn-select">Create</button>
              <div className="ms-box-ct">
                <h5>Workflow AI Agent</h5>
                <p>
                  A multi agentic AI automation that leverages artificial
                  intelligence to automate workflows and end to end processes
                  with human in the loop controls and feedback.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    };

    const displayWalkthroughTemplate = () => {
      return (
        <div className="ms-ct ms-p1 scrollable">
          <div className="ms-title">
            <div className="ms-flex-title">
              <h1 className="ai-coach-text">Welcome to Supervity</h1>
              <div className="rt-btns">
                {currentOrganization?.isAdmin ? (
                  <button
                    className="btn btn-primary"
                    onClick={() => this.props.history.push("/pricing")}
                  >
                    Pricing
                  </button>
                ) : null}

                {currentOrganization?.isAdmin ? (
                  <button
                    className="btn btn-outline"
                    data-toggle="modal"
                    data-target="#inviteModal"
                  >
                    + Invite Team Members
                  </button>
                ) : null}
              </div>
            </div>
            {/* { <span className="sm-tag">Supervity AI Coach</span> } */}
            <h2>Configure personalized AI Coach for your team</h2>
          </div>

          {/* Web Walkthrough */}
          <div className="ms-flex">
            <div
              className="ms-box"
              data-toggle="modal"
              data-target="#recordModal"
              onClick={() =>
                this.setState({
                  TEMPLATE: "In-App Walkthrough",
                })
              }
            >
              <div className="ms-box-icon">
                <img src={enablementIcon} />
              </div>
              <button className="btn btn-select">Create</button>
              <div className="ms-box-ct">
                <h5>Web Co-browsing AI Agent</h5>
                <p>
                  Create and share in-app walkthrough AI agents for your
                  organizational web applications to digitally enable your
                  employees, customers and suppliers etc. AI Coach can also be
                  connected with a collection of knowledge to answer user
                  queries in natural language.
                </p>
              </div>
            </div>
            {getDesktopWalkthrough()}
          </div>
        </div>
      );
    };
    const automationTemplate = () => {
      return (
        <div className="ms-ct ms-p2 scrollable">
          <div className="ms-title">
            {/* <span className="sm-tag">Supervity AI Coach</span> */}
            <div className="ms-flex-title">
              <h1 className="ai-coach-text">Welcome to Supervity</h1>
            </div>
            <h2>Configure personalized AI Coach for your team</h2>
          </div>
          <div className="ms-flex">
            <div
              className="ms-box"
              data-toggle="modal"
              data-target="#recordModal"
              onClick={() =>
                this.setState({
                  TEMPLATE: "WebAutomation",
                })
              }
            >
              <div className="ms-box-icon">
                <img src={automationIcon} />
              </div>
              <div className="ms-box-ct">
                <h5>Web AI Agent</h5>
                <p>
                  Save time and effort in performing repetitive tasks across web
                  applications. Capture and replay the web automation steps
                  easily to create AI Agent.
                </p>
              </div>
            </div>
            <div
              className="ms-box"
              data-toggle="modal"
              data-target="#recordModal"
              onClick={() =>
                this.setState({
                  TEMPLATE: "Import Data from Spreadsheet to Web App",
                })
              }
            >
              <div className="ms-box-icon">
                <img src={excelIcon} />
              </div>
              <div className="ms-box-ct">
                <h5>Data Entry AI Agent</h5>
                <p>
                  Effortlessly import data from any spreadsheet to any web App.
                  Just show by doing one row entry and delegate rest to the AI
                  Agent. Set it up once and use it forever.
                </p>
              </div>
            </div>
            <div
              className="ms-box ms-blank-tp"
              data-toggle="modal"
              data-target="#recordModal"
              onClick={() =>
                this.setState({
                  TEMPLATE: "Blank Template",
                })
              }
            >
              <div className="ms-box-icon">
                <img src={blankIcon} />
              </div>
              <div className="ms-box-ct ms-blank">
                <h5>Automation from scratch</h5>
                <p className="text-center">Create your own automation</p>
              </div>
            </div>
          </div>
        </div>
      );
    };
    const email = this.props?.userReducer?.user?.email;
    const { currentOrganization } = this.props.organizationReducer;
    return (
      <>
        {this.state.defaultTemplate ? <>{displayDefaultTemplate()}</> : null}
        {this.state.showWalkthroughTemplate ? (
          <>{displayWalkthroughTemplate()}</>
        ) : null}
        {this.state.automationTemplate ? <>{automationTemplate()}</> : null}
        <div
          id="inviteModal1"
          class="modal fade crt-skill"
          role="dialog"
          data-keyboard="false"
        >
          <div class="modal-dialog">
            <div class="modal-content crt-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  onClick={(e) =>
                    this.setState({
                      collectionName: "",
                      collectionDescription: "",
                      selectedOption: "files",
                    })
                  }
                >
                  &times;
                </button>

                <div className="modal-title-flex">
                  <h4 class="modal-title"> Create collection</h4>
                  <div class="frm-block">
                    <div className="ip-tl-label">
                      <span className="tl-label">Collection Type</span>
                      <select
                        value={this.state.selectedOption}
                        onChange={(e) =>
                          this.setState({
                            selectedOption: e.target.value,
                          })
                        }
                      >
                        <option value="files" selected>
                          Unstructured Data(Files)
                        </option>
                        <option value="database">Database</option>
                        <option value="live_search">Live Search</option>
                        <option value="transcribe">Transcribe</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-body">
                <form class="form-contain" action="javascript:void(0)">
                  {!this.checkOrgFilter() ? (
                    <>
                      <div className="frm-block">
  <div className="ip-tl-label">
    <span className="tl-label">
      Name
      <a
        className="tlt-icon tl-tooltip task-table-info"
        href="javascript:void(0)"
        data-toggle="popover"
        data-html="true"
        data-trigger="hover"
        data-placement="auto top"
        data-content="Collection name must be globally unique and must start with a letter."
      >
        <img src={info} alt="" />
      </a>
    </span>
    <input
      type="text"
      name="name"
      placeholder="Enter your collection name"
      value={this.state.collectionName}
      onChange={(e) => {
        const value = e.target.value;
        const error = this.validateCollectionName(value);
        this.setState({
          collectionName: value,
          collectionNameError: error
        });
      }}
      className={this.state.collectionNameError ? "error-input" : ""}
    />
    {this.state.collectionNameError && (
      <div className="error-message" style={{
        color: 'red',
        fontSize: '12px',
        marginTop: '5px'
      }}>
        {this.state.collectionNameError}
      </div>
    )}
  </div>
</div>
                      <div class="frm-block">
                        <div className="ip-tl-label">
                          <span className="tl-label">Description</span>
                          <input
                            type="text"
                            name="description"
                            placeholder="Enter Description"
                            value={this.state.collectionDescription}
                            onChange={(e) =>
                              this.setState({
                                collectionDescription: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="frm-block"></div>
                    </>
                  ) : null}

                  {this.state.selectedOption !== "database" &&
                  !this.checkOrgFilter() ? (
                    <div class="frm-block">
                      <div className="ip-tl-label">
                        <span className="tl-label">Model</span>
                        <select
                          onChange={(e) =>
                            this.setState({
                              model: e.target.value,
                            })
                          }
                        >
                          {this.state?.models?.length > 0 ? 
                                 this.state?.models.map((obj, ind) => {
                                  return <option value={obj}>{obj}</option>
                                 }) : null
                              }
                        </select>
                      </div>
                    </div>
                  ) : null}

                  {this.state.selectedOption !== "database" &&
                  this.state.selectedOption !== "transcribe" &&
                  !this.checkOrgFilter() ? (
                    <div class="frm-block">
                      <div className="ip-tl-label">
                        <span className="tl-label">
                          Base Language
                          <a
                            class="tlt-icon tl-tooltip task-table-info"
                            href="javascript:void(0)"
                            data-toggle="popover"
                            data-html="true"
                            data-trigger="hover"
                            data-placement="auto top"
                            data-content="Supervity Collection requires that the documents being uploaded are in the base language script. Therefore, please ensure to upload your documents in the base language selected for better accuracy."
                          >
                            <img src={info} alt="" />
                          </a>
                        </span>
                        <select
                          onChange={(e) =>
                            this.setState({
                              baseLanguage: e.target.value,
                            })
                          }
                        >
                          <option value="en" selected>
                            English
                          </option>
                          <option value="es">Spanish</option>
                          <option value="ja">Japanese</option>
                        </select>
                      </div>
                    </div>
                  ) : null}

                  {this.state.selectedOption === "database" && (
                    <>

<div className="ip-tl-label">
                          <span className="tl-label">Database Type</span>
                          <select
                            onChange={(e) =>
                              this.setState({
                                databaseType: e.target.value,
                              })
                            }
                          >
                            <option value="postresql" selected>
                              PostreSQL
                            </option>
                            <option value="mssql">MSSQL</option>
                            <option value="mysql">MySQL</option>
                            <option value="oracle">Oracle DB</option>
                          </select>
                        </div>
                        
                      <div className="frm-block">
                        <div className="ip-tl-label">
                          <span className="tl-label">Database Host Name</span>
                          <input
                            type="text"
                            placeholder="Enter Host Name"
                            onChange={(e) =>
                              this.setState({
                                hostname: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      </div>
                      <div className="frm-block">
                        <div className="ip-tl-label">
                          <span className="tl-label">User Name</span>
                          <input
                            type="text"
                            placeholder="Enter User Name"
                            onChange={(e) =>
                              this.setState({
                                username: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      </div>
                      <div className="frm-block">
                        <div className="ip-tl-label">
                          <span className="tl-label">Password</span>
                          <input
                            type="text"
                            placeholder="Enter Password"
                            onChange={(e) =>
                              this.setState({
                                password: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      </div>
                      <div className="frm-block">
                        <div className="ip-tl-label">
                          <span className="tl-label">Port</span>
                          <input
                            type="text"
                            placeholder="Enter Port"
                            onChange={(e) =>
                              this.setState({
                                port: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      </div>
                      <div className="frm-block">
                        <div className="ip-tl-label">
                          <span className="tl-label">Database Name</span>
                          <input
                            type="text"
                            placeholder="Enter Database Name"
                            onChange={(e) =>
                              this.setState({
                                databasename: e.target.value,
                              })
                            }
                            required
                          />
                        </div>

                        <Checkbox
                          onChange={() =>
                            this.setState((prevState) => ({
                              isSSL: !prevState.isSSL, // Toggle the state
                            }))
                          }
                          checked={this.state.isSSL}
                        >
                          SSL Enabled
                        </Checkbox>
                      </div>

                      <div class="frm-block">
                      <div className="ip-tl-label">
                        <span className="tl-label">Model</span>
                        <select
                          onChange={(e) =>
                            this.setState({
                              model: e.target.value,
                            })
                          }
                        >
                          {this.state?.models?.length > 0 ? 
                                 this.state?.models.map((obj, ind) => {
                                  return <option value={obj}>{obj}</option>
                                 }) : null
                              }
                        </select>
                      </div>
                      </div>

                       <Checkbox
                                                  onChange={(e) => {
                                                    this.setState({advancedSettings: e.target.checked})
                                                  }}
                                                  checked={this.state.advancedSettings}
                                                >
                                                  Advanced Settings
                                                </Checkbox>
                      
                                                {this.state.advancedSettings ? (
                                                  <>
                                                  <div className="ip-tl-label">
                                                  <span className="tl-label">DB Schemas</span>
                                                  <input
                                                    type="text"
                                                    placeholder="Eg: Schema1,Schema2"
                                                    onChange={(e) => {
                                                      this.setState({dbSchemas: e.target.value})
                                                    }}
                                                    required
                                                  />
                                                </div>
                      
                                                   <div className="frm-block">
                      
                                                   <Checkbox
                                                  onChange={(e) => {
                                                    this.setState({advancedSettingsOption: 1})
                                                  }}
                                                  checked={this.state.advancedSettingsOption == 1}
                                                >
                                                  Use
                                                </Checkbox>
                                                   <Checkbox
                                                    onChange={(e) => {
                                                      this.setState({advancedSettingsOption: 2})
                                                    }}                                                 
                                                    checked={this.state.advancedSettingsOption == 2}
                                                >
                                                  Neglect
                                                </Checkbox>
                                                    </div>
                                                
                                                { this.state.advancedSettingsOption == 1 ? (
                                                  <>
                                                  <div className="frm-block">
                                                    <div className="ip-tl-label">
                                                      <span className="tl-label">Use Tables</span>
                                                      <input
                                                        type="text"
                                                        placeholder="Eg: value1, value2"
                                                        onChange={(e) => {
                                                          this.setState({useTablesList: e.target.value})
                                                        }}                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="frm-block">
                                                    <div className="ip-tl-label">
                                                      <span className="tl-label">Use Views</span>
                                                      <input
                                                        type="text"
                                                        placeholder="Eg: value1, value2"
                                                        onChange={(e) => {
                                                          this.setState({useViewsList: e.target.value})
                                                        }}                                                      />
                                                    </div>
                                                  </div>
                                                </>
                                                ) : 
                                                (
                                                  <>
                                                  <div className="frm-block">
                                                    <div className="ip-tl-label">
                                                      <span className="tl-label">Neglect view</span>
                                                      <input
                                                        type="text"
                                                        placeholder="Eg: value1, value2"
                                                        onChange={(e) => {
                                                          this.setState({neglectViewList: e.target.value})
                                                        }}                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="frm-block">
                                                    <div className="ip-tl-label">
                                                      <span className="tl-label">Neglect table</span>
                                                      <input
                                                        type="text"
                                                        placeholder="Eg: value1, value2"
                                                        onChange={(e) => {
                                                          this.setState({neglectTableList: e.target.value})
                                                        }}                                                      />
                                                    </div>
                                                  </div>
                                                </>
                                                )}
                                                </>
                                                ) : null}

                    </>
                  )}

                  {!this.checkOrgFilter() &&
                  this.state.selectedOption === "live_search" ? (
                    <>
                      <div className="frm-block">
                        <div className="ip-tl-label text-black">
                          <label>
                            <input
                              type="radio"
                              name="liveSearchOption"
                              value="web_scrape"
                              checked={
                                this.state.selectedLiveSearch === "web_scrape"
                              }
                              onChange={(e) =>
                                this.setState({
                                  selectedLiveSearch: e.target.value,
                                })
                              }
                            />
                            Web Scraping
                          </label>
                          {/* <label>
                            <input
                              type="radio"
                              name="liveSearchOption"
                              value="web_search"
                              checked={
                                this.state.selectedLiveSearch === "web_search"
                              }
                              onChange={(e) =>
                                this.setState({
                                  selectedLiveSearch: e.target.value,
                                })
                              }
                            />
                            Web Search
                          </label> */}
                        </div>
                        <div>
                          {this.state.liveSearchUrl.length === 0 ? (
                            // Show an input box even if liveSearchUrl is empty
                            <div className="flex-ip-label">
                              <div className="ip-tl-label">
                                <span className="tl-label">URL</span>
                                <input
                                  type="url"
                                  name="editLiveSearchUrl0"
                                  placeholder="Enter URL"
                                  value="" // Empty value initially
                                  onChange={(e) =>
                                    this.handleEditUrlChange(e.target.value, 0)
                                  }
                                  required={
                                    this.state.search_type === "web_scrape"
                                  }
                                />
                              </div>
                              <Tooltip title="Add New URL">
                                <Button
                                  type="primary"
                                  icon={<PlusCircleOutlined />}
                                  onClick={this.handleAddEditUrl}
                                  disabled={
                                    this.state.liveSearchUrl.length >= 5
                                  }
                                />
                              </Tooltip>
                            </div>
                          ) : (
                            this.state.liveSearchUrl.map((url, index) => (
                              <div className="flex-ip-label" key={index}>
                                <div className="ip-tl-label">
                                  <span className="tl-label">URL</span>
                                  <input
                                    type="url"
                                    name={`editLiveSearchUrl${index}`}
                                    placeholder="Enter URL"
                                    value={url || ""}
                                    onChange={(e) =>
                                      this.handleEditUrlChange(
                                        e.target.value,
                                        index
                                      )
                                    }
                                    required={
                                      this.state.search_type === "web_scrape"
                                    }
                                  />
                                </div>
                                {/* <Tooltip title="Add New URL">
                                  <Button
                                    type="primary"
                                    icon={<PlusCircleOutlined />}
                                    onClick={this.handleAddEditUrl}
                                    disabled={
                                      this.state.liveSearchUrl.length >= 5
                                    }
                                  />
                                </Tooltip> */}
                                {this.state.liveSearchUrl.length > 1 && (
                                  <Tooltip title="Delete URL">
                                    <Button
                                      type="danger"
                                      danger
                                      icon={
                                        <DeleteTwoTone twoToneColor="#fd2000" />
                                      }
                                      onClick={() =>
                                        this.handleDeleteEditUrl(index)
                                      }
                                    />
                                  </Tooltip>
                                )}
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    </>
                  ) : null}
                  {/* Response Language */}

                  {/* <div class="frm-block">
                    <div className="ip-tl-label">
                      <span className="tl-label">Response Language</span>
                      <select
                        onChange={(e) =>
                          this.setState({
                            response_language: e.target.value,
                          })
                        }
                      >
                        <option value="en" selected>
                          English
                        </option>
                        <option value="hi">Hindi</option>
                        <option value="gom">Gom</option>
                        <option value="kn">Kannada</option>
                        <option value="doi">Dogri</option>
                        <option value="brx">Bodo</option>
                        <option value="ur">Urdu</option>
                        <option value="ta">Tamil</option>
                        <option value="ks">Kashmiri</option>
                        <option value="as">Assamese</option>
                        <option value="bn">Bengali</option>
                        <option value="mr">Marathi</option>
                        <option value="sd">Sindhi</option>
                        <option value="mai">Maithili</option>
                        <option value="pa">Punjabi</option>
                        <option value="ml">Malayalam</option>
                        <option value="te">Telugu</option>
                        <option value="sa">Sanskrit</option>
                        <option value="ne">Nepali</option>
                        <option value="sat">Santali</option>
                        <option value="gu">Gujarati</option>
                        <option value="or">Odia</option>
                      </select>
                    </div>
                  </div> */}

                  <div class="frm-btns">
                    <button
                      class="btn btn-outline"
                      data-dismiss="modal"
                      onClick={(e) =>
                        this.setState({
                          collectionName: "",
                          collectionDescription: "",
                          baseLanguage: "en",
                          selectedOption: "files",
                        })
                      }
                    >
                      Cancel
                    </button>
                    <button
                      class="btn btn-primary"
                      onClick={() => this.newCollection()}
                      disabled={this.state.collectionNameError}
                    >
                      {this.state.isLoading ? (
                        <div class="sp sp-circle text-light"></div>
                      ) : (
                        "Create"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div id="recordModal" class="rc-modal modal fade" role="dialog">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                onClick={() =>
                  this.setState({
                    SKILL_NAME: "",
                    SKILL_DESCRIPTION: "",
                    editorState: "",
                    TEMPLATE: "",
                    isRecording: false,
                    SKILL_ID: null,
                    isLoading: false,
                    stopRecording: false,
                    isErrorDescription: false,
                    isError: false,
                  })
                }
              >
                {" "}
                ×
              </button>
              <div class="modal-body">
                <div className="rc-modal-icon">
                  {this.state.TEMPLATE === "UserDocumentation" && (
                    <img src={automation} />
                  )}
                  {this.state.TEMPLATE === "In-App Walkthrough" && (
                    <img src={walkthrough} />
                  )}
                  {this.state.TEMPLATE === "Desktop Walkthrough" && (
                    <img src={walkthrough} />
                  )}
                  {this.state.TEMPLATE === "UserOnboarding" && (
                    <img src={userOnboardingIcon} />
                  )}
                  {this.state.TEMPLATE === "WebAutomation" && (
                    <img src={webAutomationIcon} />
                  )}
                  {this.state.TEMPLATE === "Data Transfer" && (
                    <img src={dataTransferIcon} />
                  )}
                  {this.state.TEMPLATE ===
                    "Import Data from Spreadsheet to Web App" && (
                    <img src={dataLoading} />
                  )}
                  {this.state.TEMPLATE === "Skill Set" && (
                    <img src={skillSetImage} />
                  )}
                  {this.state.TEMPLATE === "Blank Template" && (
                    <img src={walkthrough} />
                  )}
                  {this.state.TEMPLATE === "Process Discovery" && (
                    <img src={walkthrough} />
                  )}
                  {this.state.TEMPLATE === "GenAi Automation" && (
                    <img src={walkthrough} />
                  )}
                </div>

                {this.state.isRecording === true ? (
                  <React.Fragment>
                    <h3>
                      {" "}
                      <Counter state={this.state} />{" "}
                    </h3>
                    <h4 className="tlp-title">
                      Your Training starts in a new tab. Capture all steps that
                      you would like Super to learn. Once you are done with
                      training, Click on Stop button{" "}
                    </h4>
                  </React.Fragment>
                ) : this.state.TEMPLATE === "In-App Walkthrough" ||
                  this.state.TEMPLATE === "Desktop Walkthrough" ? (
                  <h4 className="tlp-title text-center">Name Your Agent </h4>
                ) : (
                  <h4 className="tlp-title text-center">Name Your Agent </h4>
                )}
                <div className="form-contain">
                  <div className="frm-block">
                    <div className="ip-tl-label">
                      <span className="tl-label">Agent Name</span>
                      <input
                        type="text"
                        name="SKILL_NAME"
                        placeholder="Enter Agent Name"
                        value={this.state.SKILL_NAME}
                        onChange={(e) => this.onFieldChange(e)}
                        onBlur={(e) => this.checkField()}
                        maxLength={"150"}
                      />
                      <div className="charCount">
                        <span id="typed-characters">
                          {" "}
                          {this.state.SKILL_NAME?.length}
                        </span>
                        <span>/</span>
                        <span id="maximum-characters">150</span>
                      </div>

                      {this.state.isError ? (
                        <label className="error text-danger">
                          Enter Agent Name
                        </label>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="frm-block">
                    <div className="ip-tl-label">
                      <span className="tl-label">Description</span>
                      <div className="RichEditor-root">
                        <Editor
                          ref="editor"
                          spellCheck={false}
                          toolbarOnFocus={false}
                          editorState={this.state.editorState}
                          wrapperClassName="demo-wrapper"
                          editorClassName="demo-editor"
                          placeholder="Enter Description"
                          onEditorStateChange={this.onEditorStateChange}
                          onBlur={(e) => this.checkField()}
                          toolbar={toolbarOptions}
                        />
                      </div>
                      {this.state.isErrorDescription ? (
                        <label className="error text-danger">
                          Enter Agent Description
                        </label>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                {this.state.isRecording === false ? (
                  <React.Fragment>
                    {this.state.isLoading ? (
                      <button className="btn btn-primary">
                        <div class="sp sp-circle text-light"></div>
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary"
                        onClick={() => this.handleSubmit()}
                      >
                        Next <img src={backArrow} />
                      </button>
                    )}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {this.state.stopRecording ? (
                      <button className="btn btn-primary" data-dismiss="modal">
                        <div class="sp sp-circle text-light"></div>
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary"
                        onClick={() => this.onStopRecord()}
                        data-backdrop="false"
                      >
                        Stop <img src={backArrow} />
                      </button>
                    )}
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Invite Members Modal */}
        {/* <InviteModal /> */}

        {/* View More Modal */}
        <div id="viewModal" class="view-modal modal fade" role="dialog">
          <div class="modal-dialog">
            <div class="modal-content">
              <button type="button" class="close" data-dismiss="modal">
                {" "}
                ×
              </button>
              <div class="modal-body">
                <div className="tlp-icon">
                  <img src={automation} />
                </div>
                <div className="tp-content view-content">
                  <h4 className="">User Documentation</h4>
                  <p className="tlp-tex-1">
                    <strong>
                      Auto-generate visual document guides instantly by showing
                      your workflow Lorem Ipsum is simply dummy text of the
                      printing and typesetting industry. Lorem Ipsum has been
                      the industry’s standard dummy text ever since the 1500s
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Request Access Modal */}

        <div id="reqAccessModal" class="rc-modal modal fade" role="dialog">
          <div class="modal-dialog">
            <div class="modal-content">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                onClick={() =>
                  this.setState({
                    requestTemplate: "",
                  })
                }
              >
                {" "}
                ×
              </button>
              <div class="modal-body">
                <div className="rc-modal-icon">
                  {this.state.requestTemplate ===
                    "Data download for MIS reporting" && <img src={mis} />}

                  {this.state.requestTemplate ===
                    "Survey to collect inputs" && <img src={survey} />}

                  {this.state.requestTemplate === "Chat support" && (
                    <img src={chatSupport} />
                  )}

                  {this.state.requestTemplate ===
                    "Document extraction and data entry" && (
                    <img src={extraction} />
                  )}

                  {this.state.requestTemplate === "Approval workflow" && (
                    <img src={approval} />
                  )}

                  {this.state.requestTemplate === "Guided eCommerce" && (
                    <img src={ecommerce} />
                  )}

                  {this.state.requestTemplate === "Web scraping" && (
                    <img src={webScraping} />
                  )}

                  {this.state.requestTemplate === "Email support" && (
                    <img src={emailSupport} />
                  )}

                  {this.state.requestTemplate === "File format conversion" && (
                    <img src={fileFormat} />
                  )}

                  {this.state.requestTemplate === "WhatsApp support" && (
                    <img src={whatsapp} />
                  )}
                  {this.state.requestTemplate === "Messenger support" && (
                    <img src={messenger} />
                  )}
                  {this.state.requestTemplate === "Voice support" && (
                    <img src={voiceSupport} />
                  )}
                </div>
                <div className="req-template-msg ">
                  Thank you for showing interest in{" "}
                  <strong>{this.state.requestTemplate}</strong> Super automation
                  template to enable your team to be productive and creative at
                  work.
                  <br /> Our friendly Customer Success team will get in touch to
                  assist you with the onboarding.
                  <br />
                  Please click on 'Request Access' to confirm.
                  <br />
                </div>
              </div>
              <button
                className="btn btn-primary"
                data-backdrop="false"
                data-dismiss="modal"
                onClick={() => {
                  this.sendAccessReq();
                }}
              >
                Request Access
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  skillReducer: state.skillReducer,
  userReducer: state.userReducer,
  appReducer: state.appReducer,
  snackReducer: state.snackReducer,
  organizationReducer: state.organizationReducer,
});
export default compose(
  withRouter,
  connect(mapStateToProps, {
    createDraftSkill,
    notify,
    startRecord,
    stopRecord,
    changeActiveTab,
    addMemberToOrganization,
    sendRequestAccess,
    getSheetHeaders,
    getDraftSkills,
    createGenAiSkill,
    createAgentV2,
  })
)(SkillStart);
